import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import FilteredChecksGroup from './../Form/FilteredChecksGroup';
import { startsWith, toPairs, lowerCase } from 'lodash';
import categoryFilterShape from '../../pages/StartPage/Dashboard/components/DashboardFilters'

import LightSpinnerWrapper from '../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper';
import ChecksGroup from "../Form/ChecksGroup";

class CategoryFilter extends Component {

    static propTypes = {
        selectedCategories: PropTypes.shape(categoryFilterShape),
        switchCategory:     PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.changeCategorySelection = this.changeCategorySelection.bind(this);
        this.changeAllCategory = this.changeAllCategory.bind(this);
        this.state = {
            allCategories: props.selectedCategories.allCategories,
            allUnassigned: props.selectedCategories.allUnassigned,
            options: this.composeOptions(props)
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            options: this.composeOptions(nextProps),
            allCategories: nextProps.selectedCategories.allCategories,
            allUnassigned: nextProps.selectedCategories.allUnassigned
        });
    }

    composeOptions(props) {
        let categories = toPairs(props.categories);
        return categories.map(option => ({
            key: option[0],
            value:      props.selectedCategories.categoriesId.indexOf(option[0]) > -1,
            label:      option[1]
        }));
    }

    categoriesSelectedCount() {
        let categorySelected = false
        this.state.options.forEach(item => (item.value ? categorySelected = true : null))
        return categorySelected
    }

    changeAllCategory(options, option, e) {
        if (option.key === "assigned") {
            if (option.value) {
                this.setState({
                    options: this.state.options.map(item => ({ ...item, value: false})),
                    allCategories: true
                }, this.switchCategory);
            } else {
                if (this.categoriesSelectedCount() && !this.state.allUnassigned) {
                    this.setState({
                        options: this.state.options.map(item => ({ ...item, value: true})),
                        allCategories: false
                    }, this.switchCategory);
                } else if (this.state.allUnassigned) {
                    this.setState({
                        allCategories: false
                    }, this.switchCategory);
                } else {
                    this.setState({
                        allCategories: true,
                        allUnassigned: true
                    }, this.switchCategory);
                }
            }
        } else {
            if (option.value) {
                this.setState({ allUnassigned: true }, this.switchCategory);
            } else {
                if (this.categoriesSelectedCount() || this.state.allCategories) {
                    this.setState({
                        allUnassigned: false
                    }, this.switchCategory);
                } else {
                    this.setState({
                        allCategories: true,
                        allUnassigned: true
                    }, this.switchCategory);
                }
            }
        }
    }

    switchCategory() {
        this.props.switchCategory({
            categories: {
                allCategories: this.state.allCategories,
                allUnassigned: this.state.allUnassigned,
                categoriesId:  this.state.options.filter(option => option.value).map(options => options.key)
            }
        });
    }

    changeCategorySelection(options, option, e) {
        if (option.value) {
            if (this.categoriesSelectedCount() > 1) { // if there is a category selected except the one that is already checked
                this.setState({ allCategories: false, options }, this.switchCategory)
            } else {
                if (this.state.allUnassigned && this.state.allCategories) {
                    this.setState({ allCategories: false, allUnassigned: false, options }, this.switchCategory)
                } else {
                    this.setState({ allCategories: false, options }, this.switchCategory)
                }
            }
        } else {
            if (this.categoriesSelectedCount() || this.state.allUnassigned) {
                this.setState({ options }, this.switchCategory);
            } else {
                this.setState({ allCategories: true, allUnassigned: true, options }, this.switchCategory);
            }
        }
    }

    filterFn(item, filterStr) {
        return (lowerCase(item.label).indexOf(lowerCase(filterStr)) > -1 || filterStr === "" || item.key === "assigned"
            || item.key === "unassigned");
    }

    render() {
        let options = [
            {
                key: "assigned",
                label: this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.filters.allAssigned'}),
                value: this.state.allCategories
            },
            {
                key: "unassigned",
                label: this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.filters.allUnassigned'}),
                value: this.state.allUnassigned
            }]
        const specialCategories = <ChecksGroup options={options} onChange={this.changeAllCategory}/>
        return (
            <LightSpinnerWrapper isLoading={!this.state.options.length}>
                <FilteredChecksGroup
                    placeholderMessageId="General_CoreFunctionality_UIText_find.category"
                    filterFn={this.filterFn}
                    onChange={this.changeCategorySelection}
                    options={this.state.options}
                    before={specialCategories} />
            </LightSpinnerWrapper>
        );
    }

}

export default injectIntl(CategoryFilter);



// WEBPACK FOOTER //
// ./src/scripts/reusable/Dropdowns/Category.filter.jsx